import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBellOff"><Path d="M22.4141 21L21 22.4141L16.0859 17.5H3L3.81348 9.35645C3.9349 8.22317 4.28191 7.16375 4.80762 6.22168L1.58594 3L3 1.58594L22.4141 21Z" fill="currentColor"/><Path d="M16.584 19C15.8124 20.7659 14.0503 22 12 22C9.94971 22 8.18756 20.7659 7.41602 19H16.584Z" fill="currentColor"/><Path d="M12 2C16.2078 2 19.7382 5.17264 20.1865 9.35645L20.917 16.6748L7.5498 3.30762C8.83795 2.47882 10.3676 2.00001 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBellOff;
